export default __webpack_public_path__ + "static/media/0x8f006d1e1d9dc6c98996f50a4c810f17a47fbf19.8498098a.webp";